import searchIndex from "../public/search-index.json";
import MiniSearch from "minisearch";

const search = MiniSearch.loadJS(searchIndex, {
    fields: ["name", "desc"],
    storeFields: ["name", "type", "desc", "url"]
});
addEventListener('message', (event) => {
	const result = search.search(event.data.query, {
      prefix: true,
      boost: {
        "name": 1,
        "desc": 0.7
      },
      fuzzy: (term) => {
        if ( term.length >= 5 ) {
          return 0.2;
        }
        return false
      }
    }).slice(0, 50);

	postMessage({context: event.data, result});
});
